import { useNavigate } from 'react-router-dom';
import { useAckAnnouncement, useAnnouncements } from '@/hooks/queries';
import { useAuth } from '@/store/auth';
import { CheckIcon } from '@/components/ui/icons';

/**
 * The one place an unread announcement cannot be missed: a bar above the
 * page. Only the newest unacknowledged one shows — a stack of banners would
 * teach people to dismiss without reading.
 */
export function AnnouncementBanner() {
  // The banner sits above every page, so it asks for announcements on screens
  // that have nothing to do with the Company page. Somebody without that
  // product is not shown them, and must not be made to ask.
  const features = useAuth((state) => state.features);
  const { data } = useAnnouncements(features.includes('company'));
  const ack = useAckAnnouncement();
  const navigate = useNavigate();

  const pending = (data?.items ?? []).find(
    (item) => item.requireAck && !item.acked && !item.closedAt,
  );
  if (!pending) return null;

  return (
    <div className="flex items-center gap-3 border-b border-brand-500/30 bg-brand-600/15 px-4 py-2">
      <button
        type="button"
        className="min-w-0 flex-1 truncate text-left text-sm text-ink hover:underline"
        onClick={() => navigate('/company')}
        title={pending.body || pending.title}
      >
        <span className="font-semibold">Announcement:</span> {pending.title}
      </button>
      <button
        type="button"
        className="btn-secondary btn-sm shrink-0"
        disabled={ack.isPending}
        onClick={() => ack.mutate(pending.id)}
      >
        <CheckIcon size="sm" />
        Got it
      </button>
    </div>
  );
}
